import { useRuntimeConfig } from "nuxt/app";

export type AnalyticsProperties = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: AnalyticsProperties[];
  }
}

export const pushDataLayerEvent = (
  event: string,
  properties: AnalyticsProperties = {}
) => {
  if (!import.meta.client) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ...properties, event });
};

export const useAnalytics = () => {
  const posthog = usePostHog();
  const config = useRuntimeConfig();
  const appName = String(config.public.ANALYTICS_APP_NAME || "unknown");

  const push = (event: string, properties: AnalyticsProperties = {}) => {
    pushDataLayerEvent(event, {
      app_name: appName,
      ...properties
    });
  };

  const capture = (event: string, properties: AnalyticsProperties = {}) => {
    if (Object.keys(properties).length > 0) {
      posthog?.capture(event, properties);
    } else {
      posthog?.capture(event);
    }
    push(event, properties);
  };

  return { capture, push };
};
